'use client';

/**
 * Productpagina-variant van de herkomstmelding: volgt de gekozen uitvoering via
 * het bestaande `printen:pricing`-event van de configurator. Nodig voor
 * producten waarvan maar een deel van de formaten buiten de EU wordt gemaakt.
 */
import { useEffect, useState } from 'react';
import { ShippingOriginNotice } from './shipping-origin-notice';

export function ShippingOriginNoticeLive({
  productId,
  productSlug,
  specifications,
  initialSku,
  locale,
}: {
  productId: string;
  productSlug: string;
  specifications?: unknown;
  initialSku: string | null;
  locale: string;
}) {
  const [sku, setSku] = useState<string | null>(initialSku);

  useEffect(() => {
    const update = (event: Event) => {
      const detail = (event as CustomEvent<{ productId?: string; variantSku?: string | null }>).detail;
      if (!detail || (detail.productId && detail.productId !== productId)) return;
      if (typeof detail.variantSku === 'string' && detail.variantSku) setSku(detail.variantSku);
    };
    window.addEventListener('printen:pricing', update);
    return () => window.removeEventListener('printen:pricing', update);
  }, [productId]);

  return (
    <ShippingOriginNotice
      productId={productId}
      productSlug={productSlug}
      specifications={specifications}
      sku={sku}
      locale={locale}
    />
  );
}
